import React from 'react';

const NotFound = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="300"
    data-name="Layer 1"
    viewBox="0 0 752 613.121"
  >
    <path
      fill="#3f3d56"
      d="M936.067 644.816c13.152 46.82-113.439 153.79-336.162 94.075-179.323-48.08-336.161-68.443-336.161-94.075s150.504 1.254 336.161 1.254 329.23-25.93 336.162-1.254z"
      transform="translate(-224 -143.44)"
    />
    <path
      d="M936.067 644.816c13.152 46.82-113.439 153.79-336.162 94.075-179.323-48.08-336.161-68.443-336.161-94.075s150.504 1.254 336.161 1.254 329.23-25.93 336.162-1.254z"
      opacity="0.1"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#3f3d56"
      d="M936.067 644.816c13.152 46.82-113.439 106.126-336.162 46.41-179.323-48.08-336.161-20.778-336.161-46.41s150.504-46.41 336.161-46.41 329.23 21.733 336.162 46.41z"
      transform="translate(-224 -143.44)"
    />
    <ellipse cx="484" cy="526" opacity="0.1" rx="26" ry="9" />
    <ellipse cx="590" cy="526" opacity="0.1" rx="26" ry="9" />
    <ellipse cx="376" cy="486" opacity="0.1" rx="85" ry="23" />
    <path
      fill="#3f3d56"
      d="M976 559.44v-416H224v416h347v55.609c-17.331 2.075-29 5.95-29 10.39 0 6.628 25.967 12 58 12s58-5.372 58-12c0-4.44-11.669-8.315-29-10.39v-55.61z"
      transform="translate(-224 -143.44)"
    />
    <path fill="#f2f2f2" d="M39 14.574H713V387.425H39z" />
    <text
      textAnchor="start"
      x="240"
      y="150"
      fontFamily="Muli"
      fontSize="200.5"
      fill="LightSeaGreen"
      transform="translate(36 505.5) rotate(-140 200 -30)"
    >
      <textPath href="#lost-msg">404</textPath>
    </text>
    <path
      id="lost-msg"
      d="M937 158.44s-280 29-331 141-343 231-343 231h674z"
      opacity="0.1"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#2f2e41"
      d="M811.246 336.44v27.648H707.754V338.13h-3v331.31h3v-59.313h103.492v59.313h3v-333zm0 30.648v45.607H707.754v-45.607zM707.754 509.911v-45.607h103.492v45.607zm103.492 3v45.608H707.754V512.91zm-103.492-51.607v-45.609h103.492v45.609zm0 145.823V561.52h103.492v45.608z"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#191e38"
      d="M675.121 343.023v4.144s-2.96 1.184-2.96 5.92-2.368 22.497-2.368 22.497 4.144 3.552 7.696 2.368a14.463 14.463 0 005.328-2.96l.592-18.353-2.368-4.736v-8.288zM788.378 178.44s-10.296 1.184-10.296 5.92-8.237 22.497-8.237 22.497 14.415 3.552 26.77 2.368 18.533-2.96 18.533-2.96l2.06-18.353-8.238-4.736z"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#ffb8b8"
      d="M789.382 219.881v-11.248s-12.433-24.865-2.368-24.865 11.248 22.497 11.248 22.497v15.984zM682.817 337.695s-6.512-3.553-7.696 0-4.736 11.248 0 11.84 9.472-3.552 9.472-3.552z"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#2f2e41"
      d="M714.869 361.676s-3.565 4.708 1.607 50.64 2.192 79.376 12.01 78.918c0 0-2.562 9.96 5.781 10.327s12.156.946 12.805-1.355 1.667-12.946-.6-12.84c0 0 .142 3.021 1.088-9.134s-1.733-69.558 1.69-77.287l13.39 27.382s.6 12.84 3.147 18.776 7.947 40.504 7.947 40.504l-.509 5.323s18.268 2.174 18.883-.882.402-7.588-.423-9.064-.826-1.475.543-4.567a9.156 9.156 0 00.403-7.588c-.861-2.23-3.153-51.324-3.153-51.324s-4.296-59.598-13.501-62.196-61.108 4.367-61.108 4.367z"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#2f2e41"
      d="M730.964 495.66l-5.549 10.856s-9.6-2.958-7.306 5.64a151.098 151.098 0 0027.551-1.665s3.847 1.334 4.497-.967-2.365-10.109-4.63-10.003-14.563-3.862-14.563-3.862zM774.63 490.593s-5.407 13.877-3.106 14.527 22.835 2.719 24.38 3.403 9.135 1.088 9.678-3.48-4.058-5.865-4.058-5.865-8.379-1.123-10.997-8.57-15.897-.015-15.897-.015z"
      transform="translate(-224 -143.44)"
    />
    <circle cx="499.357" cy="89.825" r="15.814" fill="#ffb8b8" />
    <path
      fill="#ffb8b8"
      d="M715.033 240.756s4.162 21.64 2.497 25.802 23.306-1.665 23.306-1.665-4.994-21.64-4.162-26.635-21.64 2.498-21.64 2.498z"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#2f2e41"
      d="M722.876 213.731a8.939 8.939 0 00-3.956.175 10.315 10.315 0 00-2.811 1.844 32.906 32.906 0 01-4.807 3.185 11.216 11.216 0 00-3.74 2.622 7.958 7.958 0 00-1.056 1.998 23.944 23.944 0 00-1.259 13.031 5.99 5.99 0 00.555 1.79c.865 1.594 2.776 2.222 4.385 3.057 3.056 1.587 5.372 4.258 7.879 6.618a15.402 15.402 0 003.113 2.4c3.575 1.949 7.946 1.313 11.96.623a2.155 2.155 0 002.151-2.176l3.168-14.25a23.249 23.249 0 00.812-6.48c-.22-3.46-2.093-8.251-4.632-10.709-2.958-2.863-7.895-3.318-11.762-3.728z"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#575a88"
      d="M711.235 267.836s1.184-8.289 8.288-8.88a58.57 58.57 0 0011.84-2.369c.592 0 8.289.592 11.841 4.144 0 0 2.368 3.552 3.552 1.184s1.184-3.552 3.552-2.368 2.368-3.552 6.513-2.96 14.8 27.233 14.8 27.233l-3.552 4.144s-4.736 31.97 3.552 45.586 11.84 28.418 3.552 31.378-66.307 29.601-63.938 13.024.592-42.626-1.777-43.218-15.392-47.362-15.392-47.362a18.389 18.389 0 0110.656-13.616c9.473-4.144 6.513-5.92 6.513-5.92z"
      transform="translate(-224 -143.44)"
    />
    <path
      fill="#575a88"
      d="M753.86 258.955l2.96-2.368s5.329 0 5.92-1.184 3.553-1.184 5.921-2.368-.592-2.96 2.368-4.144 2.96 0 2.96-2.96 7.697-5.92 8.289-9.473 6.512-20.129 6.512-20.129l11.248 3.552-2.96 21.313s0 10.657-5.328 17.761-17.169 24.865-23.089 25.457-14.8-25.457-14.8-25.457zM697.618 284.412l-3.552 2.96s-1.184 13.025-1.184 13.617 1.184 7.696 0 8.288-3.552 12.433-2.96 13.025v1.776l-8.289 13.025v12.432l19.537-12.432s11.249-1.184 9.473-11.249-13.025-41.442-13.025-41.442z"
      transform="translate(-224 -143.44)"
    />
    <circle cx="376" cy="405" r="11" fill="#191e38" />
  </svg>
);

export default NotFound;
